import { GstInvoiceItem } from './GstInvoiceItem'

export default GstInvoiceItem
